import React, { useState } from 'react';
import './CitationsDisplay.css';

interface WebSearchResult {
  title: string;
  url: string;
  snippet: string;
  publishedDate?: string;
  source?: string;
}

interface CitationsDisplayProps {
  results: WebSearchResult[];
  searchQuery?: string;
  className?: string;
}

const CitationsDisplay: React.FC<CitationsDisplayProps> = ({
  results,
  searchQuery,
  className = ''
}) => {
  const [expanded, setExpanded] = useState(false);

  if (!results || results.length === 0) return null;

  const getDomain = (url: string) => {
    try {
      return new URL(url).hostname.replace('www.', '');
    } catch {
      return url;
    }
  };

  const getSiteName = (result: WebSearchResult) => {
    return result.source || getDomain(result.url);
  };

  return (
    <div className={`citations-display ${className}`}>
      <div className="citations-header">
        <div className="header-content">
          <div className="search-indicator">
            <i className="fas fa-globe-americas"></i>
            <span className="search-label">Web Sources</span>
            {searchQuery && (
              <span className="search-query">"{searchQuery}"</span>
            )}
          </div>
          <button
            className="expand-toggle"
            onClick={() => setExpanded(!expanded)}
          >
            <i className={`fas fa-chevron-${expanded ? 'up' : 'down'}`}></i>
            <span>{results.length} source{results.length !== 1 ? 's' : ''}</span>
          </button>
        </div>
      </div>

      <div className={`citations-content ${expanded ? 'expanded' : 'collapsed'}`}>
        <div className="citations-grid">
          {results.map((result, index) => (
            <a
              key={index}
              href={result.url}
              target="_blank"
              rel="noopener noreferrer"
              className="citation-card citation-card--link"
            >
              <div className="citation-header">
                <div className="citation-number">{index + 1}</div>
                <div className="citation-source">
                  <span className="source-name">{getSiteName(result)}</span>
                  <span className="citation-ext-icon">
                    <i className="fas fa-arrow-up-right-from-square"></i>
                  </span>
                </div>
              </div>
              <div className="citation-content">
                <h4 className="citation-title">{result.title}</h4>
                <p className="citation-snippet">{result.snippet}</p>
              </div>
              <div className="citation-footer">
                <span className="citation-url">{getDomain(result.url)}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CitationsDisplay;
